import React, { useEffect, useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Css/Manavseva.css";
import Header from '../Component/Header';
const Manavseva = () => {
  const [title, setTitle] = useState("");
  const [pdf, setPdf] = useState(null);
  const [image, setImage] = useState(null);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState("");
  const [files, setFiles] = useState([]);

  useEffect(() => {
    fetchFiles();
  }, []);



  
  const fetchFiles = async () => {
    try {
      const response = await axios.get(
        "https://api.gkaglobal.org/restgka/admin/manavsevafile.php"
      );
      console.log("Fetch Respose", response.data);
      if (response.data.status === "success") {
        setFiles(
          response.data.pdf_files.map((pdf_file, index) => ({
            id: response.data.pdf_ids[index],
            pdf: pdf_file,
            image: response.data.image_files[index],
            baseurl: response.data.baseurl,
          }))
        );
        console.log("Data...", response);
      }
    } catch (error) {
      console.error("Error fetching files", error);
    }
  };


  const handleUpload = async (e) => {
    e.preventDefault();
    


    
    if (!image || !title || !pdf) {
      setMessage("All fields are required");
      return;
    }
  
    const formData = new FormData();
    formData.append("image", image);
    formData.append("title", title);
    formData.append("pdf", pdf);
  
    // Add retry logic
    const maxRetries = 3;
    let retryCount = 0;
    let lastError = null;
  
    while (retryCount < maxRetries) {
      try {
        const response = await axios.post(
          "https://api.gkaglobal.org/restgka/admin/umanavseva.php",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              const percentComplete = Math.round(
                (progressEvent.loaded / progressEvent.total) * 100
              );
              setProgress(percentComplete);
            },
            timeout: 120000, // 2 minutes timeout
          }
        );
  
        console.log("Upload Response:", response.data);
  
        if (response.data.status === true || response.data.status === "success") {
          setMessage("File uploaded successfully");
          setTitle("");
          setPdf(null);
          setImage(response.data);
          setProgress(0);
          fetchFiles(); // optionally reload files
          return; // Exit the function on success
        } else {
          // If server returns error but connection was successful
          lastError = response.data.message;
          if (response.data.message.includes('MySQL server') || 
              response.data.message.includes('database')) {
            retryCount++;
            await new Promise(resolve => setTimeout(resolve, 2000 * retryCount)); // Exponential backoff
            continue;
          }
          setMessage("Server Error: " + response.data.message);
          return;
        }
      } catch (error) {
        console.error("Upload Error:", error);
        lastError = error;
        
        if (error.response?.data?.message) {
          if (error.response.data.message.includes('MySQL server') || 
              error.response.data.message.includes('database')) {
            retryCount++;
            await new Promise(resolve => setTimeout(resolve, 2000 * retryCount)); // Exponential backoff
            continue;
          }
          setMessage("Upload Failed: " + error.response.data.message);
        } else if (error.code === "ECONNABORTED") {
          retryCount++;
          await new Promise(resolve => setTimeout(resolve, 2000 * retryCount));
          continue;
        } else {
          setMessage("Upload Failed: " + error.message);
        }
        return;
      }
    }
  
    // If we've exhausted all retries
    setMessage(`Upload failed after ${maxRetries} attempts. Last error: ${lastError?.message || lastError}`);
  };  


  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this file?")) return;

    console.log("Deleting file with ID:", id);

    try {
      const response = await axios.post(
        "https://api.gkaglobal.org/restgka/admin/dmanavseva.php",
        JSON.stringify({ id }),
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      console.log("Delete Response:", response.data);

      if (response.data.status === "success") {
        alert("File deleted successfully");

        setFiles((prevFiles) => prevFiles.filter((file) => file.id !== id));

        fetchFiles();
      } else {
        alert("Failed to delete file: " + response.data.message);
      }
    } catch (error) {
      console.error("Error deleting file:", error);
      alert("Error deleting file");
    }
  };

  return (
    <>

 
    <div className="file-upload-container">
      {/* Upload Form */}
      <form className="upload-form" onSubmit={handleUpload}>
        <h2 className="text-center">Upload PDF and Image</h2>
        <div className="mb-3">
          <label className="form-label">Title:</label>
          <input
            type="text"
            className="form-control"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">PDF File:</label>
          <input
            type="file"
            className="form-control"
            accept="application/pdf"
            onChange={(e) => setPdf(e.target.files[0])}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Image File:</label>
          <input
            type="file"
            className="form-control"
            accept="image/*"
            onChange={(e) => setImage(e.target.files[0])}
            required
          />
        </div>
        <div className="progress mb-3">
          <div
            className="progress-bar progress-bar-striped"
            style={{ width: `${progress}%` }}
          >
            {progress}%
          </div>
        </div>
        <button type="submit" className="btn btn-primary w-100">
          Upload
        </button>
        {message && <p className="text-center mt-3">{message}</p>}
      </form>

      {/* Table Section */}
      <div className="table-container">
        <h2 className="text-center">MANAVSEVA</h2>
        <div className="table-responsive">
          <table className="table table-bordered mt-3">
            <thead>
              <tr>
                <th>#</th>
                <th>Image</th>
                <th>PDF</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {files.length > 0 ? (
                files.map((file, index) => (
                  <tr key={file.id}>
                    <td>{index + 1}</td>
                    <td>
                      <img
                        src={file.baseurl + file.image}
                        alt="img"
                        style={{ width: "100px" }}
                      />
                    </td>
                    <td>
                      <a
                        href={file.baseurl + file.pdf}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {file.pdf}
                      </a>
                    </td>
                    <td>
                      <button
                        className="btn btn-danger"
                        onClick={() => handleDelete(file.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No files found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </>
  );
};

export default Manavseva;
